import { createSlice } from "@reduxjs/toolkit";
import { ISlots } from "./typing/slot.interface";
import reducers from "./slot.reducers";
export const initialStateSlots: ISlots = {
  providers: [],
  savedGames: {
    _main: {
      games: [],
      count: 0,
    },
  },
  favouriteGames: localStorage.getItem("favorite_slots")
    ? //@ts-ignore
      (JSON.parse(localStorage.getItem("favorite_slots")) as {
        src: string;
        title: string;
        id: number;
        top: boolean;
        recs: boolean;
        new: boolean;
        live: boolean;
        type: "big" | "wide" | undefined;
        disabled: boolean;
      }[])
    : [],
  // games: [],
  // page: 1,
  // gamesCount: 0,
  // isFiltered: false,
  searchGame: null,
  // selectProvider: null,
  // filters: [],
  isDemo: false,
  bigWins: [],
};

export const slotsSlice = createSlice({
  name: "slots",
  initialState: initialStateSlots,
  reducers,
});

export const {
  setDemo,
  setSlots,
  setProvider,
  // updateSlots,
  // clearSlots,
  // setPage,
  // setFilter,
  findGame,
  clearFilter,
  setBigWins,
  addBigWin,
  setFavoriteGame,
} = slotsSlice.actions;

export default slotsSlice.reducer;
